import { PRINT_PREVIEW_KEY } from '../consts/print';
import { useRouter } from '../no-code/hooks/useRouter';

export default function useIsPrintPreview() {
  const { searchParams } = useRouter();
  return searchParams.get(PRINT_PREVIEW_KEY) === 'true';
}
